interface SellYoursModuleProps {
  sellUrl: string;
  brand: string;
  model: string;
}

export default function SellYoursModule({ sellUrl, brand, model }: SellYoursModuleProps) {
  return (
    <div
      className="flex-1 bg-[#fbfbfb] rounded-[2rem] shadow-[2px_2px_15px_0px_rgba(0,0,0,0.25)] p-[2.4rem] flex flex-col items-center text-center gap-[1.2rem]"
    >
      <p className="text-[1.8rem] font-extrabold text-black leading-[1.3]">
        Have a {brand} {model} sitting in your bag?
      </p>
      <p className="text-[1.4rem] text-brand-dark-gray leading-[1.5]">
        You&apos;d be the first listing for this model.<br /> Serious buyers are
        already watching &mdash; list yours in minutes.
      </p>
      <a
        href={sellUrl}
        className="mt-auto inline-block w-full bg-black text-white font-bold rounded-[1rem] px-[2.4rem] py-[0.8rem] text-[1.4rem] text-center hover:bg-gray-800 transition-colors duration-150"
      >
        Sell your {brand} {model} on GearFocus
      </a>
    </div>
  );
}
